module.exports = __webpack_public_path__ + "img/IEEE-RAS_2023.1bd99e98.png";